import Toast, { useToast } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(Toast, {
    closeOnClick: false,
    hideProgressBar: true,
    icon: false,
    containerClassName: 'toast-container'
  })

  const toast = useToast()
  nuxtApp.vueApp.config.globalProperties.$toast = toast
})

